"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeedActivities = exports.getActivityFeedURLSearchString = exports.GET_FEEDS_API_UNIQUE_KEY = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const lodash_es_1 = require("lodash-es");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const activityFiltersConfig_1 = require("../constants/activityFiltersConfig");
const PAGE_SIZE = 20;
exports.GET_FEEDS_API_UNIQUE_KEY = 'feedActivities';
const getActivityFeedURLSearchString = ({ entityIDs, filters, updateActivityTypes, pageParam = 1, }) => {
    const params = { orderByDesc: 'true', page: String(pageParam), pageSize: String(PAGE_SIZE) };
    const searchParams = new URLSearchParams(params);
    (0, lodash_es_1.forEach)(entityIDs, (entityID) => {
        searchParams.append('entityID', entityID);
    });
    (0, lodash_es_1.forEach)((0, lodash_es_1.keys)(filters), (filterKey) => {
        if (filters[filterKey]) {
            (0, activityFiltersConfig_1.getActivityTypes)(filterKey, updateActivityTypes).forEach((activityType) => {
                searchParams.append('activityTypes', activityType);
            });
        }
    });
    return searchParams.toString();
};
exports.getActivityFeedURLSearchString = getActivityFeedURLSearchString;
const useFetchFeedActivities = (entityIDs, filters, updateActivityTypes) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return async ({ pageParam }) => {
        const url = `${config.FEED_CORE_V2_ENDPOINT}/feed?${(0, exports.getActivityFeedURLSearchString)({
            entityIDs,
            filters,
            updateActivityTypes,
            pageParam,
        })}`;
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
};
const useFeedActivities = (entityIDs, filters, updateActivityTypes) => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const fetchFeedActivities = useFetchFeedActivities(entityIDs, filters, updateActivityTypes);
    return (0, frontend_infra_reactquery_1.useInfiniteQuery)({
        queryKey: [exports.GET_FEEDS_API_UNIQUE_KEY, entityIDs, filters],
        queryFn: async ({ pageParam }) => {
            try {
                return await fetchFeedActivities({ pageParam });
            }
            catch (e) {
                snackService.showError(translate('activity_feed_v2-load_error'));
                return Promise.reject(e);
            }
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.page * lastPage.pageSize < lastPage.total) {
                return lastPage.page + 1;
            }
            return null;
        },
        initialPageParam: 1,
    });
};
exports.useFeedActivities = useFeedActivities;
//# sourceMappingURL=useFetchFeedActivities.js.map